import { useQuery } from "@tanstack/react-query";
import { getWABotSchedules } from "apis/botSchedule";

export function useWABotSchedules(payload = {}, options = {}) {
  return useQuery({
    queryKey: ["WABotSchedules", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getWABotSchedules(payload);
        response = data; // { data: [...item], total, current_page, ... }
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}
